import $ from 'jquery';
import { isOnDanish } from "../../modernjs/utils/is-on-language";

export function addClearButtons(context) {
    const clearContainerFactory = () => $(`<div class="clear-button-container"></div>`);
    
    const clearButtonFactory = () => $(`
        <button class="clear-button primary-background" type="button" >
            <span class="clear-button__icon secondary-text">&times;</span>
        </button>
    `);

    $('input.simple-input', context)
        .not($('.no-clear input.simple-input'))
        .not('.js-added-clear-button')
        .not('.no-clear')
        .each(function () {
            const input = this;
            const $input = $(this);
            $input.addClass('js-added-clear-button');

            const container = clearContainerFactory();
            container.insertBefore($input);
            container.append($input);

            const clearBtn = clearButtonFactory();
            container.append(clearBtn);

            clearBtn.click(function () {
                $input.val('');
                $input.trigger('input');
                $input.trigger('change');
            });

            const label = $(`label[for=${$input.attr('id')}]`).first().text();
            const labelText = label && label.split(':')[0] || '';
            const ariaLabel = isOnDanish() ? `ryd ${labelText} felt` : `clear ${labelText} field`;
            clearBtn.attr('aria-label', ariaLabel);

            const updateBtnVisibility = (value) => {
                if (value) {
                    clearBtn.removeClass('is-hidden');
                } else {
                    clearBtn.addClass('is-hidden');
                }
            };

            $input.on('input', function (e) {
                updateBtnVisibility(e.target.value);
            });
            updateBtnVisibility(input.value);
        });
}

addClearButtons(); // run it on instantiation
